var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.3724C29.2645 12.7733 28.4744 13.0441 27.6438 13.1666C28.5008 12.5358 29.142 11.5429 29.4477 10.3733C28.6425 10.9616 27.7612 11.3757 26.8422 11.5977C26.2242 10.786 25.4057 10.248 24.5136 10.0672C23.6216 9.88638 22.706 10.0729 21.909 10.5978C21.1119 11.1228 20.4781 11.9567 20.1058 12.9701C19.7336 13.9836 19.6437 15.1199 19.8503 16.2026C18.2187 16.1018 16.6226 15.5801 15.1655 14.6715C13.7085 13.7628 12.423 12.4874 11.3926 10.928C11.0403 11.6757 10.8377 12.5425 10.8377 13.4656C10.8373 14.2967 11.0036 15.115 11.322 15.848C11.6404 16.581 12.1009 17.2059 12.6627 17.6675C12.0112 17.642 11.374 17.4254 10.8042 17.0358V17.1008C10.8041 18.2664 11.1319 19.3961 11.7319 20.2982C12.3318 21.2004 13.1671 21.8194 14.0958 22.0503C13.4914 22.2515 12.8577 22.2811 12.2426 22.137C12.5046 23.1399 13.0151 24.0169 13.7024 24.6452C14.3898 25.2735 15.2197 25.6217 16.0759 25.641C14.6224 27.0446 12.8273 27.806 10.9795 27.8026C10.6521 27.8027 10.3251 27.7792 10 27.7322C11.8757 29.2157 14.0591 30.003 16.2891 30C23.8378 30 27.9644 22.3092 27.9644 15.6391C27.9644 15.4224 27.96 15.2036 27.9521 14.9869C28.7548 14.2728 29.4476 13.3886 29.9982 12.3756L30 12.3724V12.3724Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWTwitter);
export default __webpack_public_path__ + "static/media/w_twitter.1c4828f1d4f213b74fb5b9f6295068bd.svg";
export { ForwardRef as ReactComponent };